import { InputLabel, Stack } from '@mui/material';
import MUICheckbox, { CheckboxProps } from '@mui/material/Checkbox';

interface Props extends CheckboxProps {
  checked: boolean;
  children: React.ReactNode;
  id: string;
  labelClassName?: string;
}

const Checkbox = ({
  id,
  children,
  labelClassName,
  className,
  style,
  ...props
}: Props) => {
  return (
    <Stack direction="row" alignItems="center" className={className}>
      <MUICheckbox id={id} size="small" {...props} />
      <InputLabel htmlFor={id} className={labelClassName} style={style}>
        {children}
      </InputLabel>
    </Stack>
  );
};

export default Checkbox;
